import React, { useRef, useState } from 'react'
import { InputButton } from '../InputButton'
import styles from './Select.module.scss'
import { useOutsideAlerter } from '../../helpers/useHandleOutsideClick'
import FormattedMessage from '../../helpers/FormattedMessage'

interface IProps {
  children: React.ReactNode
  onChange: (value: number | string) => void
  values: number[] | string[]
  title?: string
  postText?: string
  rotate?: boolean
}

export const Select = ({ children, values, onChange, postText, rotate }: IProps) => {
  const ref = useRef(null)
  const [isActive, setIsActive] = useState(false)
  const toggle = () => {
    setIsActive(state => !state)
  }

  useOutsideAlerter({
    ref,
    onClick: () => {
      setIsActive(false)
    }
  })

  return (
    <div className={styles.Select} ref={ref}>
      <InputButton
        label="SchoolShop.stage2.title"
        onClick={toggle}
        select={rotate}
      >
        {children}
      </InputButton>
      {isActive &&
      <div className={styles.SelectContent}>
        {values.map((item, index) => (
          <div className={styles.SelectItem} key={index} onClick={() => {
            onChange(item)
            toggle()
          }}>
            {postText ? <FormattedMessage id={postText} values={{ item: item.toString() }}/> : item}
          </div>
        ))}
      </div>
      }
    </div>
  )
}
